<template>
    <Header></Header>
    <div class="container min-height padding-top-default">
        <div class="dashboard-main z-index">
            <LeftBar></LeftBar>
            <div class="right-bar">
                <template v-if="profile?.verification && profile.verification?.value !== '2'">
                    <div class="text danger mb-4">
                        <p class="mb-2"><b>Внимание</b>, Ваш аккаунт не верифицирован, пройдите проверку KYC чтобы получить доступ ко всем функциям платформы:</p>
                        <div class="mb-2">Доступно:</div>
                        <div>✅ Пополнение</div>
                        <div class="mt-3 mb-2">Недоступно:</div>
                        <div>❌ Вывод</div>
                        <div>❌ Покупка</div>
                        <div>❌ Продажа</div>
                        <router-link to="/dashboard/settings/verification" class="button button-success mt-3">Пройти проверку KYC</router-link>
                    </div>
                </template>
                <router-view></router-view>
            </div>
        </div>
    </div>
    <Footer></Footer>
    <div class="modal-window" v-if="modalStatus">
        <div class="modal-close"></div>
        <div class="modal-content ellipse ellipse-after">
            <h1 class="modal-title text-center">🚨 ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ 🚨</h1>
            <span class="modal-subtitle text-center">Уважаемые пользователи!</span>
            <div class="text p-0 mb-2">
                ⚠️ Информируем вас о том, что наша компания не работает и не принимает операции с рядом криптовалютных платформ и сервисов.
            </div>
            <div class="text p-0 mb-2">
                ❌ Проведение транзакций, имеющих прямую или косвенную связь с указанными ниже площадками, строго запрещено.
            </div>
            <div class="text p-0 mb-2">
                📋 Список платформ, с которыми мы не сотрудничаем (включая аффилированные и связанные сервисы):
            </div>
            <div class="text p-0">
                - grinex.io
                <br />- bitpapa.com
                <br />- capitalist.net
                <br />- rapira.net
                <br />- meer.kg
                <br />- 1xbet и все связанные с ним субъекты
                <br />- Aifory.pro
                <br />- terminal.cash
                <br />- nobitex.ir и любые иранские и другие платформы подобных санкционных стран
                <br />- SkyCrypto.net
                <br />- FlashObmen.com
                <br />- 60cek.net
                <br />- hd-change.com
                <br />- CoinBlinker.com
                <br />- Metka.cc
                <br />- AlfaBit.org
                <br />- Heleket
                <br />- Vexel
                <br />- Fun Pay
                <br />- Web Money
                <br />- Freekassa
                <br />- Yobit
                <br />- exmo.com
                <br />- exmo.me
                <br />- Crypto Cloud
                <br />- Cripta
                <br />- BitBits
                <br />- Nix Money
                <br />- Bixter
                <br />- Payeer.com
                <br />а также платформы, прекратившие операционную деятельность, но сохраняющие историческую связь с ранее проведёнными транзакциями.

                <br /><br />🚫 Обратите внимание! В случае совершения депозита или вывода средств с указанных платформ:
                <br /><br />🔒 Средства могут быть заморожены,
                <br /><br />⛔ Заблокированы,
                <br /><br />💸 Либо утеряны в рамках процедур проверки и соблюдения требований AML / Compliance.
            </div>
            <label class="form-agree mt-4">
                <input type="checkbox" class="form-checkbox" v-model="agree" required>
                <span>Подтверждаю, что ознакомлен(а) с перечнем платформ, с которыми компания не осуществляет взаимодействие.</span>
            </label>
            <button class="button block lg mt-4" type="button" :class="!agree && 'disabled'" v-on:click="closeModal">Закрыть</button>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import LeftBar from '@/components/Account/LeftBar.vue'
import Footer from '@/components/Footer.vue'

export default {
    data() {
        return {
            agree: false,
            modalStatus: false
        }
    },
    components: {
        Header,
        LeftBar,
        Footer
    },
    created() {
        this.modalStatus = localStorage.getItem('blackListReaded') ? false : true
    },
    computed: {
        profile() {
            return (this.$store.getters.getProfile)
            ? this.$store.getters.getProfile
            : this.$store.dispatch('getProfile')
        }
    },
    methods: {
        closeModal() {
            if(this.agree) {
                localStorage.setItem('blackListReaded', true)
                this.modalStatus = false
            }
        }
    }
}
</script>